import { isEmpty } from 'lodash-es';
import { Controller } from "stimulus";
import ManageableCards from '../entrypoints/src/admin/components/manageable_cards';
import 'select2';
import 'select2/dist/css/select2';
import GuardianStorage from '../entrypoints/src/admin/storages/guardian_storage';
import GuardianService from '../entrypoints/src/admin/services/guardian-service';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import Swal from 'sweetalert2';
import StudentService from '../entrypoints/src/admin/services/student-service';
import { fillSelectedPerson } from '../entrypoints/src/admin/utilities/fill_person_to_form';

export default class extends Controller {
  static targets = ['birth', 'incapable']
  connect() {
    this.$guardians = this.element.querySelector('.enrollment-guardians');
    this.$emptyMessage = this.element.querySelector('.enrollment-guardians-empty-message');

    this.paymentDefaultValues = this.capturePaymentDefaultValues();

    this.initializeIncapable(document.querySelector('.student-form'));
    this.birthTarget.addEventListener('change', () => this.birthChange());
    this.handleManagerCards();

    document.body.addEventListener('guardian-storage-updated', (ev) => {
      this._guardians = undefined;
      document.querySelectorAll('div.entry-card.guardian-card').forEach(($el) => {
        this.initializeGuardianCard($el);
      });
    });

    document.addEventListener('card:removed', (ev) => {
      this.handleFinancialOfficerOnRemoval(ev.detail.card);
    });
  }

  handleManagerCards() {
    new ManageableCards(this.element.querySelector('[data-manageable-cards].manageable-guardians'), {
      validate: ($card) => {
        let kinshipDegree = $card.querySelector('select.kinship-degree'),
          kinshipDegreeValidate = !isEmpty(kinshipDegree.value),
          guardianName = $card.querySelector('.select2-guardian'),
          guardianNameValidate = !isEmpty(guardianName.value) && guardianName.value.length > 2;

        this.formGroupStatus(kinshipDegree, !kinshipDegreeValidate);
        this.formGroupStatus(guardianName, !guardianNameValidate);
        return kinshipDegreeValidate && guardianNameValidate;
      },
      initialize: this.initializeGuardianCard.bind(this),
      printOutput: ($card) => {
        let $kinshipDegree = $card.querySelector('select.kinship-degree'),
            $inputEmail = $card.querySelector('[data-email-validation]');
        !!$kinshipDegree && ($card.querySelector('.kinship-degree-type').innerHTML = `${$kinshipDegree.options[$kinshipDegree.selectedIndex].innerHTML} <div>${$card.querySelector('.financial-officer-checkbox').checked ? '<span class="badge badge-purple">responsável financeiro</span>' : ''}</div>` );
        $card.querySelector('.person-detail .person-name').innerHTML = `${$card.querySelector('.select2-guardian').value.toLowerCase()}`;
        $card.querySelector('.person-detail .user-email').innerHTML = $inputEmail.value.toString().length == 0 ? '' : `<i class="fas fa-user text-sm mr-2"></i> ${$card.querySelector('[data-email-validation]').value}`;
        $card.querySelectorAll('.contact-number').forEach(($el) => !isEmpty($el.value) && ($card.querySelector('.person-detail .person-phone').innerHTML = `<i class="fas fa-phone text-sm mr-2"></i> ${$el.value}`));

        this.checkForFinancialOfficer();
      }
    });
  }

  formGroupStatus(el, showError) {
    el.closest('.form-group').classList.toggle('error', showError);
    el.closest('.form-group').classList.toggle('has-error', showError);
  }

  initializeIncapable($scope) {
		if (!this.incapableTarget)
			return;

    if(!!$scope.querySelector('.guardian-card') || (!!this.birthTarget.value  && !this.isAdult(this.birthTarget.value))){
      this.incapableTarget.checked = true;
      $('#guardians-fields').collapse('show');
    }
  }

  incapableToggle() {
    $('#guardians-fields').collapse('toggle');
  }

  initializeGuardianCard($card) {
    this.$inputEmail = $card.querySelector('[data-email-validation]');
    !!this.$inputEmail && this.$inputEmail.addEventListener('user-component:selected', (ev) => this.handleSelectedUser(ev, $card));

    let $financialOfficer = $card.querySelector('.financial-officer-checkbox');
    !!$financialOfficer && $financialOfficer.addEventListener('click', (ev) => this.handleUniqFinancialOfficer(ev, $card));

    this.bindGuardianSelection($card);
  }

  handleSelectedUser(ev, $card) {
    let user = ev.detail.user;

    if (+this.element.dataset.studentId == user.person.id && $card.querySelector('input[type="checkbox"].accept').checked) {
      return this.alertDuplicatedPerson($card);
    }

    if (user.person.type == 'student' && !user.person.guardian) {
      return this.askToConvertToGuardian(user).then(async (result) => {
        if (result.isConfirmed) {
          AjaxLoader.show();
          let response = await StudentService.toGuardian(user.person.id);

          var newOption = new Option(user.person.name, user.person.name, false, false);
          $($card.querySelector('.select2-guardian')).append(newOption).trigger('change');

          if (!!response)
            await this.respondAnswer(result, ev, $card);
        } else {
          ev.target.value = '';
        }
      });
    }

    if (user.person.type == 'guardian_enroll' || user.person.guardian) {
      this.askToFill(user).then(async (result) => this.respondAnswer(result, ev, $card));
    }
  }

  handleUniqFinancialOfficer(ev, $card) {
    let $checkbox = $card.querySelector('.financial-officer-checkbox');

    if (!$checkbox.checked)
      return;

    this.$guardians.querySelectorAll('.guardian-card .financial-officer-checkbox').forEach((it) => {
      it.checked = false;
      it.closest('.entry-card').dispatchEvent(new Event('printOutput'));
    });

    $checkbox.checked = true;
    $card.dispatchEvent(new Event('printOutput'));
  }

  capturePaymentDefaultValues() {
    return {
      maturity_day: $('#enrollment_maturity_day').val(),
      bank_account_id: $('#enrollment_bank_account_id').val(),
      payment_method_id: $('#enrollment_payment_method_id').val()
    };
  }

  checkForFinancialOfficer() {
    const financialOfficerCard = this.$guardians.querySelector('.guardian-card .financial-officer-checkbox:checked');

    if (financialOfficerCard) {
      this.syncPaymentProfileGuardian(financialOfficerCard.closest('.entry-card'));
    } else {
      this.applyDefaultPaymentValues();
    }
  }

  async syncPaymentProfileGuardian($card) {
    const $financialOfficer = $card.querySelector('.financial-officer-checkbox');
    if (!$financialOfficer.checked) return;

    const personAttributesIdElement = $card.querySelector('.person-attributes-id');
    const guardianId = personAttributesIdElement ? personAttributesIdElement.value : null;
    if (!guardianId) return;

    const financialOfficer = await GuardianService.find(guardianId);
    const paymentProfile = financialOfficer.payment_profile || {};

    if (Object.keys(paymentProfile).length === 0) {
      this.applyDefaultPaymentValues();
      return;
    }

    ['maturity_day', 'bank_account_id', 'payment_method_id'].forEach((attr) => {
      const value = paymentProfile[attr] || null;
      $(`#enrollment_${attr}`).val(value).trigger('change').prop('disabled', !!value);
    });
  }

  handleFinancialOfficerOnRemoval($card) {
    const $financialOfficer = $card.querySelector('.financial-officer-checkbox');
    if ($financialOfficer && $financialOfficer.checked) {
      this.applyDefaultPaymentValues();
    }
  }

  applyDefaultPaymentValues() {
    ['maturity_day', 'bank_account_id', 'payment_method_id'].forEach((attr) => {
      $(`#enrollment_${attr}`).val(this.paymentDefaultValues[attr]).trigger('change').prop('disabled', false);
    });
  }

  alertDuplicatedPerson($card) {
    Swal.fire({
      title: 'Atenção',
      html: `
        Esse e-mail, já está sendo utilizado pela matrícula que você está editando. <br><br>
        Por favor, utilize outro e-mail para o responsável, ou exclua o usuário do aluno. <br><br>

        <span class="text-sm">
          Dica: Você sabia que o responsável pode acessar o portal do aluno e visualizar as informações dos seus dependentes?
        </span>
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCloseButton: true,
      showCancelButton: true,
      showConfirmButton: false,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      onClose: (result) => {
        $card.querySelector('input[type="checkbox"].accept').checked = false;
      }
    });
  }

  async respondAnswer(result, ev, $card) {
    let user = ev.detail.user,
      $input = ev.target,
      $textMessage = $input.closest('.form-group').querySelector('.input-group ~ span');

    AjaxLoader.show();

    if (result.isConfirmed) {
      let guardian = await GuardianService.byEmail(user.email);
      fillSelectedPerson(guardian, $card.querySelector('.guardian-wrapper-form'));
      $input.dataset.emailValidation = user.email;
      $($card.querySelector('.select2-guardian'))
        .val(guardian.name)
        .trigger('change');
    } else {
      $input.value = '';
    }

    AjaxLoader.hide();

    if (!$textMessage)
      return;

    $textMessage.innerHTML = '';
    $textMessage.setAttribute('class', '');
  }

  async bindGuardianSelection($card) {
    let data = await this.guardians(),
      $selectGuardian = $card.querySelector('.select2-guardian'),
      dataGuardian = data.find((el) => el.name === $selectGuardian.dataset.value);

    if (!dataGuardian) {
      data.push({ id: $selectGuardian.dataset.value, name: $selectGuardian.dataset.value, _id: $selectGuardian.dataset.id });
    }

    $($selectGuardian).select2({
      language: "pt-BR",
      placeholder: 'Nome do Responsável',
      data: data,
      tags: true,
      debug: true,
      allowClear: true,
      multiple: false,
      closeOnSelect: true,
      dropdownParent: $card.querySelector('.modal'),
      matcher: this.matchCustom,
      escapeMarkup: function (markup) { return markup },
      templateResult: (guardian) => guardian.loading ? guardian.text : guardian.name,
      templateSelection: (guardian) => (!guardian.id || !guardian.name) ? guardian.text : guardian.name
    }).on('select2:select', (ev) => this.onGuardianSelect(ev, $card, $selectGuardian));

    if (!!$selectGuardian.dataset.value) {
      $($selectGuardian).val($selectGuardian.dataset.value).trigger('change');
      $card.dispatchEvent(new Event('printOutput'));
    }

    setTimeout(() => {
      $selectGuardian.dataset.persisted === 'true' && !dataGuardian && GuardianStorage.update();
    }, 500);
  }

  askToConvertToGuardian(user) {
    return Swal.fire({
			title: 'Atenção',
      type: 'warning',
			html: `
        Esse e-mail já está em uso pelo aluno <b>${user.person.name}</b>. <br><br>
        Tem certeza de que gostaria de utilizá-lo como responsável?
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Atribuir como responsável',
			cancelButtonText: 'Cancelar',
		});
  }

  askToFill(user) {
    return Swal.fire({
			title: 'Atenção',
      type: 'warning',
			html: `
        Esse e-mail já está em uso pelo responsável <b>${user.person.name}</b>. <br><br>
        Gostaria de utilizá-lo?
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Sim, utilizar',
			cancelButtonText: 'Cancelar',
		});
  }

  matchCustom(params, data) {
    if (!data.name)
      return null;

    if ($.trim(params.term) === '' || data.name.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
      return data;
    }

    return null;
  }

  async onGuardianSelect(ev, $card, $select) {
    let guardianSelected = ev.params.data,
      $wrapperForm = $card.querySelector('.guardian-wrapper-form');

    if (typeof guardianSelected === 'object' && !!guardianSelected._id) {
      let guardian = await GuardianService.find(guardianSelected._id);
      fillSelectedPerson(guardian, $wrapperForm);
    }
  }

  birthChange() {
    if(!this.birthTarget.value)
      return;

    const adult = this.isAdult(this.birthTarget.value);
    this.incapableTarget.checked = !adult;
    $('#guardians-fields').collapse(adult ? 'hide' : 'show');
  }

	isAdult(birthDatein){
    const bdate = birthDatein.split('/').map((v,i) => v = (i==2) ? Number(v)+18 : Number(v)).reverse(); // (dd/mm/yyyy => yyyy+18/mm/dd)
    const bday18 = new Date(bdate);
    const today = new Date();
    return (bday18 <= today)
  }

  async guardians() {
    if (!!this._guardians)
      return this._guardians;

    let response = await GuardianService.all();
    this._guardians = response.map((guardian) => { return { id: guardian.name, name: guardian.name, _id: guardian.id } });
    return this._guardians;
  }
}